import { render } from "./vl-calendar.vue?vue&type=template&id=3336d8df"
import script from "./vl-calendar.vue?vue&type=script&lang=js"
export * from "./vl-calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__